import api from '@/apis/cre/cRERepExportListAPI.js';
import apiCre from '@/apis/cre/cRERepListAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('cRERepExportList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'cre_rep_export_list',
    field: {
      key: 'cre_rep_export_list_id',
      // code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataExportBCTC(context, payload) {
    return await api.getDataExportReport(payload || {});
  },

  /**
   * Lấy dữ liệu xuất khẩu báo cáo TC
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataBCTC(context, payload) {
    return await apiCre.getList(payload || {});
  },

  /**
   * Lấy dữ liệu xuất khẩu báo cáo TC nộp cho KBNN
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataExportReportKBNN(context, payload) {
    return await api.getList(payload || {});
  },

  /**
   * Lấy dữ liệu nhập khẩu tkt mới nhất
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getTKTInfo() {
    return await api.getTKTInfo();
  },

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async export(context, payload) {
    return await api.export(payload);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
